import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material';
import { InputWrapper } from './InputWrapper';

export const RadioGroupField = ({
  name,
  label,
  options,
  required = false,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InputWrapper
          label={label}
          required={required}
          error={!!error}
        >
          <RadioGroup {...field} row {...other}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Typography variant="caption" color="text.primary">
                    {option.label}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </InputWrapper>
      )}
    />
  );
};
